import * as React from 'react';
import { useDispatch } from 'react-redux';
import Avatar from 'antd/lib/avatar';
import Flex from 'antd/lib/flex';
import Text from 'antd/lib/typography/Text';
import Tooltip from 'antd/lib/tooltip';
import { LogoutOutlined, SettingOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { tryLogout } from '../../../actions/login';
import { antGrey, runwayColors, navSectionTitleStyle, navFlexItemStyle } from '../../styles/globalStyles';
import { HoverableNavItem } from '../shared/HoverableNavItem';

export const OrgMetricsSection: React.FC<{
    orgLetter: string;
    orgName: string;
    orgImageUrl?: string;
    onOrgClick: () => void;
}> = ({ orgLetter, orgName, orgImageUrl, onOrgClick }) => (
    <Flex vertical>
        <Text style={navSectionTitleStyle}>Org Metrics</Text>
        <HoverableNavItem onClick={onOrgClick}>
            <Flex align="center" gap={12} style={navFlexItemStyle}>
                <Avatar size={28} src={orgImageUrl} style={{ flexShrink: 0 }}>
                    {orgLetter}
                </Avatar>
                <Text style={{ color: antGrey.grey1, ...navFlexItemStyle }} ellipsis>
                    {orgName}
                </Text>
            </Flex>
        </HoverableNavItem>
    </Flex>
);

export const UserSection: React.FC<{
    userLetter: string;
    userName: string;
    userAvatarUrl?: string;
    onUserClick: () => void;
}> = ({ userLetter, userName, userAvatarUrl, onUserClick }) => {
    const dispatch = useDispatch();

    const handleLogout = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(tryLogout());
    };

    return (
        <Flex vertical>
            <Text style={navSectionTitleStyle}>Profile</Text>
            <HoverableNavItem onClick={onUserClick}>
                <Flex align="center" gap={12} style={{ ...navFlexItemStyle, padding: '2px 0px' }}>
                    <Avatar
                        size={28}
                        src={userAvatarUrl}
                        style={{
                            flexShrink: 0,
                            backgroundColor: runwayColors.primary,
                            border: `1px solid ${antGrey.grey1}`,
                        }}
                    >
                        {userLetter}
                    </Avatar>
                    <Text style={{ color: antGrey.grey1, ...navFlexItemStyle }} ellipsis>
                        {userName}
                    </Text>
                </Flex>
                <Flex align="center" gap={10}>
                    <Tooltip title="Sign out" mouseEnterDelay={0.4}>
                        <LogoutOutlined style={{ color: antGrey.grey6, fontSize: 16 }} onClick={handleLogout} />
                    </Tooltip>
                    <Tooltip title="Settings" mouseEnterDelay={0.4}>
                        <SettingOutlined style={{ color: antGrey.grey6, fontSize: 16 }} onClick={onUserClick} />
                    </Tooltip>
                </Flex>
            </HoverableNavItem>
        </Flex>
    );
};

export const InviteSection: React.FC<{
    onInviteClick: () => void;
}> = ({ onInviteClick }) => {
    return (
        <HoverableNavItem onClick={onInviteClick}>
            <Flex align="center" gap={12} style={{ padding: '2px 0px' }}>
                <Flex align="center" justify="center" style={{ width: 28, height: 28 }}>
                    <UsergroupAddOutlined style={{ color: antGrey.grey7, fontSize: 20 }} />
                </Flex>
                <Text style={{ color: antGrey.grey1 }}>Invite your team</Text>
            </Flex>
        </HoverableNavItem>
    );
};
